module.exports = __webpack_public_path__ + "img/antenna-05.d018c561.svg";